import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { HeaderActionEventFromHeader, PORTFOLIO_HEADER_EVENTS } from './portfolio-header-events.model';

/**
 * Portfolio ← Header action consumer. Listens for taps on the controls
 * {@link PortfolioHeaderEventProducerService} put in the header.
 */
@Service({ autoProvided: false })
export class PortfolioHeaderEventConsumerService {
	private readonly eventBus = inject(EventBusService);

	readonly headerAction$ = this.eventBus.on$<HeaderActionEventFromHeader>(PORTFOLIO_HEADER_EVENTS.HEADER_ACTION).pipe(
		filter(Boolean),
		distinctUntilChanged((prev, curr) => prev.id === curr.id)
	);
}
